import React from 'react';

function AboutUs() {
  return <></>;
}

export default AboutUs;
